define('controllers/modules/calendar/item/session',[
    // Libs
    'underscore', 'backbone', 'moment', 'mustache', 'utils',
    'services/i18n',
    // Contoller super class
    'src/controller/controller',
    // Models
    'models/calendar/session',
    'models/calendar/item/animated-session',
    // Views | Layout
    'views/modules/calendar/animated-session/animated-session-panel',
    'views/modules/calendar/animated-session/session-week-panel',
], function(
    // Libs
    _, Backbone, moment, Mustache, U, i18n,
    // controller
    Controller,
    // Models
    MSession,
    MAnimatedSessionItem,
    // Views | Layout
    VAnimatedSessionPanel,
    VSessionWeekPanel
) {

    var CalendarSessionCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*new': 'newRoute',
            ':sessionId(/)': 'editRoute',
            ':sessionId/item/:itemId(/)': 'viewRoute',
            ':sessionId/item/:itemId/feedback(/)': 'feedbackRoute',
        },
        subRoutes: {
            session: "{{{sessionId}}}",
        },

        initialize: function(prefix, opt) {
            _.extend(this, {
                view: {},
                role: opt.role,
                model: {
                    session: new MSession()
                }
            });
        },

        weekLazyInit: function() {
            var view = this.view.week;
            if (!view) {
                var modelObj = this.model,
                    item = modelObj.item = new MAnimatedSessionItem();

                view = this.view.week = new VSessionWeekPanel({
                    model: item,
                    profile: this.profile,
                    role: this.role,
                    group: this.group,
                    url: this.url.session,
                    conversationId: this.conversationId,
                    session: this.model.session,
                });

                this.listenTo(view, {
                    'back': this.onBack,
                });
            }
            return this.getLayout();
        },

        editViewLazyInit: function() {
            this.model.session.resetExerciseCollection();
            var view = this.view.edit;
            if (!view) {
                view = this.view.edit = new VAnimatedSessionPanel({
                    model: this.model.session,
                    group: this.group,
                    profile: this.profile,
                    url: this.url.root,
                    role: this.role
                });
                this.listenTo(view, 'back', this.onBack);
            }
            this.view.edit.render();
            return this.getLayout();
        },

        _editRoute: function() {
            var view = this.view,
                editView = view.edit,
                weekView = view.week;

            if (weekView) weekView.disable();
            this.getLayout().getContent()
                .setInfoContent(editView, { open: true });
        },

        _viewRoute: function() {
            var view = this.view,
                editView = view.edit,
                weekView = view.week;
            this.model.session.resetExerciseCollection();

            if (editView) editView.disable();
            this.getLayout().getContent()
                .setInfoContent(weekView, { open: true });
        },

        ////////////
        // routes //
        ////////////
        newRoute: function(groupId, userId, dayId) {
            var content = this.editViewLazyInit().getContent();
            if (this.view.week) this.view.week.disable();
            this.when([
                content.toggleInfoOverlay(false),
                this.profile.fetch()
            ]).then(function() {
                this.model.session.resetToNew(
                    userId === "me" ? this.profile.id : userId,
                    moment(dayId)
                );
                content.setInfoContent(this.view.edit, { open: true });
            });

        },
        editRoute: function(groupId, userId, conversationId, dayId, sessionId) {
            if (!this.isConversationUrl()) {
                sessionId = dayId;
                dayId = conversationId;
            }

            var content = this.editViewLazyInit().getContent(),
                model = this.model.session;

            model.resetToId(sessionId, userId, { silent: true });

            return this.when([
                model.fetch({ force: true }),
                content.toggleInfoOverlay(false)
            ]).then(this._editRoute);
        },

        viewRoute: function(groupId, userId, conversationId, dayId, sessionId, itemId) {
            if (!this.isConversationUrl()) {
                itemId = sessionId;
                sessionId = dayId;
                dayId = conversationId;
            } else {
                this.conversationId = conversationId;
            }

            var content = this.weekLazyInit().getContent(),
                date = moment(dayId),
                model = this.model.session,
                item = this.model.item;

            // if (this.isConversationUrl()) this.view.week.setConversationId(conversationId);


            model.resetToId(sessionId, userId, { silent: true });
            item.resetToId(itemId, userId, { silent: true });

            return this.when([
                model.fetch({ history: true, date: dayId, force: true }),
                item.fetch({ force: true }),
                content.toggleInfoOverlay(false)
            ]).then(this._viewRoute);
        },

        feedbackRoute: function(groupId, userId, dayId, sessionId, itemId) {
            return this.viewRoute(groupId, userId, dayId, sessionId, itemId)
                .then(this.onFeedbackAction.bind(this));
        },

        isConversationUrl: function() {
            return Backbone.history.getFragment().indexOf('messages') > -1;
        },

        ////////////
        // events //
        ////////////
        onFeedbackAction: function() {
            this.view.week.showFeedback();
        },

        onBack: function() {
            this.trigger('back');
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },
    });

    return CalendarSessionCtrl;
});

